import { render, staticRenderFns } from "./Line.vue?vue&type=template&id=7b39d03c&"
import script from "./Line.vue?vue&type=script&lang=ts&"
export * from "./Line.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductDiscountLabels: require('/home/vsts/work/1/a/NuxtApp/components/product/DiscountLabels.vue').default,BaseInputNumber: require('/home/vsts/work/1/a/NuxtApp/components/base/InputNumber.vue').default,CartFavorite: require('/home/vsts/work/1/a/NuxtApp/components/cart/Favorite.vue').default,BaseIcon: require('/home/vsts/work/1/a/NuxtApp/components/base/Icon.vue').default,ProductPrice: require('/home/vsts/work/1/a/NuxtApp/components/product/Price.vue').default})
